export const FEEDBACK_SET_STEP = 'FEEDBACK_SET_STEP'
export const FEEDBACK_SET_RATING = 'FEEDBACK_SET_RATING'
export const FEEDBACK_SET_COMMENT = 'FEEDBACK_SET_COMMENT'
export const FEEDBACK_SET_LIKES = 'FEEDBACK_SET_LIKES'
export const FEEDBACK_SET_ANSWER = 'FEEDBACK_SET_ANSWER'
export const FEEDBACK_SET_META = 'FEEDBACK_SET_META'
